module.exports = __webpack_public_path__ + "img/stop-rent-locker-icon.1520556a.svg";